import { Message } from "@cohesive/api-client";
import { isAnswerComplete } from "../ChatHistory/messageStatus";
import { dedupeToolCallsByIndex } from "../ToolCall/dedupeToolCallsByIndex";

/**
 * Whether a turn has genuinely ended, from the data alone (the component adds
 * hysteresis on top — see HarnessTurnView).
 *
 * A turn is settled when its LAST row is a plain assistant text that has
 * reached done/processed, carries no tool calls, and the session itself is
 * idle — or when the last row terminated (failed/cancelled). Every other
 * state (streaming, a tool call in flight, an awaited confirmation, a text
 * that settled while the session still works) keeps the turn live. Requiring
 * the session to be idle is what stops a mid-turn narration line, which the
 * harness persists as `processed` the moment it finishes streaming, from
 * reading as the answer while the next tool call is still being decided.
 */
export function isTurnSettled(
  turn: Message[],
  { isSessionReady }: { isSessionReady: boolean },
): boolean {
  const last = turn[turn.length - 1];
  if (!last) return false;
  if (last.status === "failed" || last.status === "cancelled") return true;
  const settledText =
    last.origin === "assistant" &&
    !!last.content &&
    isAnswerComplete(last.status) &&
    !dedupeToolCallsByIndex(last.tool_calls)?.length;
  return settledText && isSessionReady;
}

/** The text that becomes the answer bubble once a turn is settled: its last
 *  plain-assistant text. */
export function findAnswerMessage(turn: Message[]): Message | undefined {
  for (let i = turn.length - 1; i >= 0; i--) {
    const m = turn[i];
    if (m.origin === "assistant" && !!m.content) return m;
  }
  return undefined;
}
